import { render, staticRenderFns } from "./ItineraryPageSection.vue?vue&type=template&id=37e69594&scoped=true&"
var script = {}
import style0 from "./ItineraryPageSection.vue?vue&type=style&index=0&id=37e69594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e69594",
  null
  
)

export default component.exports